import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Table, Typography } from 'antd'
import { Link, generatePath } from 'react-router-dom'
import moment from 'moment'

import { getCertStatus } from 'admin/lib/Certificates/CertificateExpiry'
import * as ROUTES from 'admin/routes'

export function CertificatesList({ certificates }) {
  const [sortOrder, setSortOrder] = useState(null)

  useEffect(() => {
    const savedSortOrder = localStorage.getItem('certificatesSortOrder')
    if (savedSortOrder) {
      setSortOrder(JSON.parse(savedSortOrder))
    }
  }, [])

  const handleTableChange = (pagination, filters, sorter) => {
    const newSortOrder = {
      order: sorter.order,
      field: sorter.field
    }
    setSortOrder(newSortOrder)
    localStorage.setItem('certificatesSortOrder', JSON.stringify(newSortOrder))
  }

  const columns = [
    {
      title: 'Certificates',
      dataIndex: 'certificateNumber',
      sorter: (a, b) => a.certificateNumber.localeCompare(b.certificateNumber),
      sortOrder:
        sortOrder?.field === 'certificateNumber' ? sortOrder.order : null
    },
    {
      title: 'Company Name',
      dataIndex: 'companyName',
      sorter: (a, b) => a.companyName.localeCompare(b.companyName),
      sortOrder: sortOrder?.field === 'companyName' ? sortOrder.order : null,
      width: '40%'
    },
    {
      title: 'Created At',
      dataIndex: 'createdAtDate',
      sorter: (a, b) => moment(a.createdAtDate) - moment(b.createdAtDate),
      sortOrder: sortOrder?.field === 'createdAtDate' ? sortOrder.order : null,
      render: (value, record) => {
        return <div>{moment(value).local().format('DD/MM/YYYY')}</div>
      }
    },
    {
      title: 'Expiration Date',
      dataIndex: 'expirationDate',
      sorter: (a, b) => moment(a.expirationDate) - moment(b.expirationDate),
      sortOrder: sortOrder?.field === 'expirationDate' ? sortOrder.order : null,
      render: (value, record) => {
        return (
          <div
            style={{
              color: getCertStatus(record).color
            }}
          >
            {moment(value).local().format('DD/MM/YYYY')}
          </div>
        )
      }
    },
    {
      title: 'Certification Scheme',
      dataIndex: 'certificationScheme',
      sorter: (a, b) =>
        a.certificationScheme.localeCompare(b.certificationScheme),
      sortOrder:
        sortOrder?.field === 'certificationScheme' ? sortOrder.order : null
    },
    {
      title: 'Certification Rating',
      dataIndex: 'certificationRating',
      sorter: (a, b) =>
        a.certificationRating.localeCompare(b.certificationRating),
      sortOrder:
        sortOrder?.field === 'certificationRating' ? sortOrder.order : null
    },
    {
      title: 'Edit',
      key: 'edit',
      width: '5rem',
      render: certificate => (
        <Typography.Text key={certificate.certificateId}>
          <Link
            to={generatePath(ROUTES.CERTIFICATES.EDIT, {
              certificateId: certificate.certificateId
            })}
          >
            Edit
          </Link>
        </Typography.Text>
      )
    }
  ]

  return (
    <Table
      columns={columns}
      dataSource={certificates}
      rowKey="certificateId"
      pagination={false}
      onChange={handleTableChange}
      style={{ width: '100%', height: '100%' }}
    />
  )
}

CertificatesList.propTypes = {
  certificates: PropTypes.arrayOf(PropTypes.object)
}
